module.exports = __webpack_public_path__ + "img/SWS_collections_2022_58_web.449a1c54.jpeg";